import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const LOCALES = [
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'ja',
  'ko',
  'zh',
  'ru',
  'hi',
  'pl',
  'cs',
  'sv',
  'no',
  'da',
  'fi',
  'nl',
  'hr',
  'ro',
  'el',
  'hu',
]

const loadResources = () => {
  var result: any = {}

  LOCALES.forEach((locale) => {
    var translation = require(`../locales/${locale}/common.json`)
    result[locale] = {
      translation: {
        ...translation,
      },
    }
  })

  return result
}

const resources = loadResources()

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    prefix: '%{',
    suffix: '}',
  },
})

export default i18n
